import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { LoadingSpinner } from './LoadingSpinner';
import { type ReactNode } from 'react';

interface Props {
    children?: ReactNode;
    role?: 'coach' | 'atleta';
}

export function ProtectedRoute({ children, role }: Props) {
    const { isAuthenticated, isLoading, role: currentRole } = useAuthStore();

    if (isLoading) return <LoadingSpinner />;

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    if (role && role !== currentRole) {
        return <Navigate to={currentRole === 'coach' ? '/coach' : '/atleta'} replace />;
    }

    return <>{children ?? <Outlet />}</>;
}
